export default function Tooltip(tooltipId, width, auto_flip) {
    var auto_flip = typeof auto_flip !== "undefined" ? auto_flip : false
    var tooltipId = tooltipId
    $("#container").append("<div id='" + tooltipId + "'></div>")

    if (width) {
        $("#" + tooltipId).css("width", width)
    }

    hideTooltip()

    function showTooltip(content, event) {
        $("#" + tooltipId).html(content)
        $("#" + tooltipId).show()

        updatePosition(event)
    }

    function hideTooltip() {
        $("#" + tooltipId).hide()
    }

    function updatePosition(event) {
        var ttid = "#" + tooltipId
        var xOffset = 20
        var yOffset = 10

        var toolTipW = $(ttid).width()
        var toolTipeH = $(ttid).height()
        // console.log("Tool tipe H "+toolTipeH);
        var windowY = $(window).scrollTop()
        var windowX = $(window).scrollLeft()
        var curX = event.pageX
        var curY = event.pageY
        var ttleft = curX + xOffset
        if (auto_flip) {
            ttleft = curX > $(window).width() / 2 ? curX - toolTipW - xOffset * 2 : curX + xOffset
        }
        if (ttleft < windowX + xOffset) {
            ttleft = windowX + xOffset
        }
        var tttop =
            curY - windowY + yOffset * 2 + toolTipeH > $(window).height()
                ? curY - toolTipeH - yOffset * 2
                : curY + yOffset
        if (tttop < windowY + yOffset) {
            tttop = curY + yOffset
        } else {
            if (auto_flip) {
                tttop = curY - toolTipeH
            }
        }

        $(ttid)
            .css("top", tttop + "px")
            .css("left", ttleft + "px")
            .css("position", "absolute")
    }

    return {
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        updatePosition: updatePosition,
    }
}
